import { Injectable } from 'angular2/core';
import { Http, Request, RequestOptionsArgs, Response, Headers } from 'angular2/http';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class ApiClient {

  constructor(
    private http: Http,
    private authHttp: AuthHttp,
    private hostUrl: string,
    private bypassAuth?: boolean
  ) {
  }

  noAuth() : ApiClient {
    return new ApiClient(this.http, this.authHttp, this.hostUrl, true);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.backend().get(this.fullUrl(url), this.appendHeaders(options));
  }

  post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.backend().post(this.fullUrl(url), body, this.appendHeaders(options));
  }

  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.backend().put(this.fullUrl(url), body, this.appendHeaders(options));
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.backend().delete(this.fullUrl(url), this.appendHeaders(options));
  }

  patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.backend().patch(this.fullUrl(url), body, this.appendHeaders(options));
  }

  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.backend().head(this.fullUrl(url), this.appendHeaders(options));
  }

  private fullUrl(url: string): string {
    return this.hostUrl + url;
  }

  private backend() : HttpBackend {
    if (this.bypassAuth) {
      return this.http;
    }
    return this.authHttp;
  }

  private appendHeaders(options?: RequestOptionsArgs): RequestOptionsArgs {
    if (!options) {
      options = {};
    }
    if (!options.headers) {
      options.headers = new Headers();
    }
    options.headers.append('Accept', 'application/json');
    options.headers.append('Content-Type', 'application/json');

    return options;
  }
}

interface HttpBackend {
  get(url: string, options?: RequestOptionsArgs): Observable<Response>;
  post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response>;
  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response>;
  delete(url: string, options?: RequestOptionsArgs): Observable<Response>;
  patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response>;
  head(url: string, options?: RequestOptionsArgs): Observable<Response>;
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/api/api-client.service.ts
 **/